export default {
  getSolutionExchangeRate: (state) => state.solutionExchangeRate,
};
